import { FormGroup, FormGroupDirective } from '@angular/forms';
import { DynamicFormModel } from './../../models/dynamic-form-model';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'ebw-monorepo-dynamic-toggle',
  templateUrl: './dynamic-toggle.component.html',
  styleUrls: ['./dynamic-toggle.component.scss']
})
export class DynamicToggleComponent {

  @Input() field: DynamicFormModel;
  formName: FormGroup;
  constructor(private formgroupDirective: FormGroupDirective) {
    this.formName = formgroupDirective.control;
  }

}
